import type React from 'react';
import styled from 'styled-components';

const IconWrapper = styled.span`
  font-size: 18px;
`;

export interface ITableIconSizeProps
  extends React.HTMLAttributes<HTMLSpanElement> {}

/**
 * Dimensione dell'icona nella tabella Cartelle e Documenti
 */
export function TableIconSize(props: ITableIconSizeProps) {
  return <IconWrapper {...props} />;
}
